let registrationPromise: Promise<ServiceWorkerRegistration | null> | null = null;

export async function registerVesselServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return null;
  }

  if (import.meta.env.DEV) {
    await unregisterVesselServiceWorker();
    return null;
  }

  if (registrationPromise) {
    return registrationPromise;
  }

  registrationPromise = import("workbox-window")
    .then(({ Workbox }) => {
      const workbox = new Workbox("/purchase-vessel-sw.js", { scope: "/" });
      return workbox.register().then((registration) => registration ?? null);
    })
    .catch(() => null);

  return registrationPromise;
}

export async function unregisterVesselServiceWorker(): Promise<void> {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(
    registrations
      .filter((registration) => registration.active?.scriptURL.includes("/purchase-vessel-sw.js"))
      .map((registration) => registration.unregister()),
  );
  registrationPromise = null;
}
